import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=3827198c"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=3827198c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports